"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageBody = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _JoinComponent = require("../JoinComponent.styled");
var _FormLabel = require("../../FormLabel/FormLabel");
var _ToolTip = require("../../ToolTip/ToolTip");
var _Join = require("../../../constants/Join");
var _readinessCheck = require("../../../constants/readinessCheck");
var _SettingsTitleTextBox = require("../Settings/SettingsTitleTextBox");
var _SettingsDescriptionTextBox = require("../Settings/SettingsDescriptionTextBox");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Component that renders the main body of the join page.
 * Contains camera preview, username/description fields, and device selectors.
 *
 * @component
 * @param {Object} props - Component props
 * @param {string} props.presenterTitle - User's full name/title
 * @param {string} props.presenterDescription - User's description/role
 * @param {string} props.checkStatus - Current status of the device check process
 * @param {Function} props.setPresenterTitle - Function to update the presenter title
 * @param {Function} props.setPresenterDescription - Function to update the presenter description
 * @param {Object} props.readinessCheck - Object containing the status of device readiness checks
 * @param {React.Element} props.microphoneSelector - Component for selecting microphone
 * @param {React.Element} props.checkAudioOutput - Component for testing audio output
 * @param {React.Element} props.cameraSelector - Component for selecting camera
 * @param {React.} props.cameraPreview - Component for previewing camera
 * @param {boolean} props.isCameraMirrored - Flag indicating if the camera is mirrored
 * @param {Function} props.toggleMirrorVideo - Function to toggle camera mirroring
 * @returns {React.Element|null} Rendered component or null if check is in progress
 */
var PageBody = exports.PageBody = function PageBody(_ref) {
  var presenterTitle = _ref.presenterTitle,
    presenterDescription = _ref.presenterDescription,
    checkStatus = _ref.checkStatus,
    setPresenterTitle = _ref.setPresenterTitle,
    setPresenterDescription = _ref.setPresenterDescription,
    readinessCheck = _ref.readinessCheck,
    microphoneSelector = _ref.microphoneSelector,
    checkAudioOutput = _ref.checkAudioOutput,
    cameraSelector = _ref.cameraSelector,
    cameraPreview = _ref.cameraPreview,
    isCameraMirrored = _ref.isCameraMirrored,
    toggleMirrorVideo = _ref.toggleMirrorVideo,
    _ref$currentPage = _ref.currentPage,
    currentPage = _ref$currentPage === void 0 ? '' : _ref$currentPage;
  var checkInProgress = checkStatus === _Join.JOIN_PAGE_STATUS.IN_PROGRESS;
  var disableInput = readinessCheck.microphone === _readinessCheck.PERMISSION_DENIED;
  var names = presenterTitle.split(' ');
  var _useState = (0, _react.useState)({
      firstName: names[0] || '',
      lastName: names.slice(1).join(' ') || ''
    }),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    userName = _useState2[0],
    setUserName = _useState2[1];
  var updateFirstName = function updateFirstName(updatedFirstName) {
    setUserName(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        firstName: updatedFirstName
      });
    });
    setPresenterTitle("".concat(updatedFirstName, " ").concat(userName.lastName));
  };
  var updateLastName = function updateLastName(updatedLastName) {
    setUserName(function (prevState) {
      return _objectSpread(_objectSpread({}, prevState), {}, {
        lastName: updatedLastName
      });
    });
    setPresenterTitle("".concat(userName.firstName, " ").concat(updatedLastName));
  };
  var updateDescription = function updateDescription(updatedPresenterDescription) {
    setPresenterDescription(updatedPresenterDescription);
  };
  if (currentPage === _Join.JOIN_PAGE.SYSTEM_CHECK || checkInProgress) return null;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCameraPreviewWrapper, null, cameraPreview), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCheckboxWrapper, {
    id: "mirror-toggle"
  }, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCheckbox, {
    type: "checkbox",
    "data-testid": 'mirror-checkbox',
    id: 'mirror-checkbox',
    checked: isCameraMirrored,
    onChange: toggleMirrorVideo
  }), /*#__PURE__*/_react["default"].createElement(_FormLabel.FormLabel, {
    label: "Mirror My Video",
    labelFor: "mirror-checkbox",
    className: "mb-0 ms-2",
    style: {
      cursor: 'pointer'
    }
  })), /*#__PURE__*/_react["default"].createElement(_ToolTip.ToolTip, {
    placement: "top",
    offset: [20, 10],
    mode: "dark",
    targetElement: 'mirror-toggle',
    message: "Mirrored video doesn't reflect to viewers. Viewers always see non-mirrored video"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react["default"].createElement(_SettingsTitleTextBox.SettingsTitleTextBox, {
    user: userName,
    isDisabled: disableInput,
    handleFirstNameChange: updateFirstName,
    handleLastNameChange: updateLastName
  })), /*#__PURE__*/_react["default"].createElement(_SettingsDescriptionTextBox.SettingsDescriptionTextBox, {
    presenterDescription: presenterDescription,
    handlePresenterDescriptionChange: updateDescription,
    isDisabled: disableInput
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "pb-4"
  }, cameraSelector), /*#__PURE__*/_react["default"].createElement("div", {
    className: "pb-4"
  }, microphoneSelector), /*#__PURE__*/_react["default"].createElement("div", {
    className: "pb-4"
  }, checkAudioOutput))));
};
PageBody.propTypes = {
  presenterTitle: _propTypes["default"].string.isRequired,
  presenterDescription: _propTypes["default"].string.isRequired,
  checkStatus: _propTypes["default"].string.isRequired,
  setPresenterTitle: _propTypes["default"].func.isRequired,
  setPresenterDescription: _propTypes["default"].func.isRequired,
  readinessCheck: _propTypes["default"].object.isRequired,
  microphoneSelector: _propTypes["default"].object.isRequired,
  checkAudioOutput: _propTypes["default"].object.isRequired,
  cameraSelector: _propTypes["default"].object.isRequired,
  cameraPreview: _propTypes["default"].object.isRequired,
  isCameraMirrored: _propTypes["default"].bool.isRequired,
  toggleMirrorVideo: _propTypes["default"].func.isRequired,
  currentPage: _propTypes["default"].string
};